export default __webpack_public_path__ + "static/media/new-no-search.0f5b636c.svg";